import { render, staticRenderFns } from "./SampleIndex.vue?vue&type=template&id=7c05722c"
import script from "./SampleIndex.vue?vue&type=script&lang=js"
export * from "./SampleIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports